export default __webpack_public_path__ + "static/media/dots.c795f4c1.svg";